import { getIsSmallScreen } from './layout';

export const getCompareLink = compareVehicles => {
	let compareBaseUrl = '';
	if (window.DDC.InvData && window.DDC.InvData.COMPARE_PAGE) {
		compareBaseUrl = window.DDC.InvData.COMPARE_PAGE;
	}
	return compareBaseUrl
		? compareBaseUrl.concat(
				`?itemIds=${encodeURIComponent(compareVehicles.join())}`
		  )
		: '';
};

/**
 * helper that lets you know whether or not to show the compare functionality
 * @param viewportWidth
 * @param enableCompare Preference
 * @param deviceType
 * @returns {boolean}
 */
export const getShouldShowCompare = (
	viewportWidth,
	enableCompare,
	deviceType
) => {
	// Compare functionality is disabled on mobile because compare pages are not styled.
	// It should be enabled after the new vehicle comparison is complete.
	const isSmallScreen = getIsSmallScreen(viewportWidth);
	return (
		enableCompare === 'true' && deviceType !== 'MOBILE' && !isSmallScreen
	);
};
